<template>
    <v-app style="margin-top:0px;">
        <v-card flat style="border-radius:0px;height:150px;margin-top: 50px;" class="tst res">
            <v-container>
                <h2 style="margin-top:70px;">Test Preparation</h2>
            </v-container>
        </v-card>
        <v-card flat style="border-radius:0px;height:100px;margin-top:50px" class="tst man">
            <v-container>
                <h2 style="margin-top:10px;">Test Preparation</h2>
            </v-container>
        </v-card>
  
        <div class="row" style="padding-top:25px;align-items: center;">
            <div class="col">
              <v-card class="partner" flat>
                  <span class="txt">Our</span><br/>
                  <span class="txt">Partners</span>
              </v-card>
            </div>
            <div class="col">
                <v-card flat>
                    <img class="center tab-logo" src="../../assets/Logoss/IELTS-logo.png" />
                </v-card>
            </div>
            <div class="col">
                <v-card flat>
                    <img class="center tab-logo" src="../../assets/Logoss/TOEFL_Logo.png" />
                </v-card>
            </div>
            <div class="col">
                <v-card flat>
                    <img class="center tab-logo" src="../../assets/Logoss/GRE_logo.png" />
                </v-card>
            </div>
            <div class="col">
                <v-card flat>
                    <img class="center tab-logo" src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
                </v-card>
            </div>
        </div>
  
        <div class="row">
            <div class="col-lg-9 col-md-9 col-sm-12">
              <v-container>
                <v-tabs
                v-if="ielts==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="cursor:pointer;background-color:#f4f4f4;color:white;" class="vtbs" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
        </v-tab>
                </v-tabs>
  
                <v-tabs
                v-if="toefl==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="border-left:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" class="tabhvr" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="cursor:pointer;background-color:#f4f4f4;color:white;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
        </v-tab>
                </v-tabs>
  
                <v-tabs
                v-if="gre==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="border:2px solid;border-color:grey !important;" class="tabhvr" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="cursor:pointer;background-color:#f4f4f4;color:white;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
        </v-tab>
                </v-tabs>
  
                <v-tabs
                v-if="sat==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="border:2px solid;border-color:grey !important;" class="tabhvr" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="cursor:pointer;background-color:#f4f4f4;color:white;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
        </v-tab>
                </v-tabs>
  
                <v-tabs
                v-if="gmat==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="border:2px solid;border-color:grey !important;" class="tabhvr" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="cursor:pointer;background-color:#f4f4f4;color:white;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
        </v-tab>
                </v-tabs>
  
                <v-tabs
                v-if="exam==true"
        v-model="tab"
        centered
  
        icons-and-text
      >
        <v-tabs-slider color="#EA0202" class="text_dec hvr"></v-tabs-slider>
  
        <v-tab href="#tab-1" style="border:2px solid;border-color:grey !important;" class="tabhvr" @click="ieltsBtn()" >
          <!-- <h5 class="tabfont">IELTS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/IELTS-logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-2" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="toeflBtn()">
          <!-- <h5 class="tabfont">TOEFL</h5> -->
                  <img class="center tab-logo"  src="../../assets/Logoss/TOEFL_Logo.png" />
  
        </v-tab>
  
        <v-tab class="tabhvr" href="#tab-3" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="greBtn()" >
          <!-- <h5 class="tabfont">GRE</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/GRE_logo.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-4" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="satBtn()">
          <!-- <h5 class="tabfont">SAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/248-2485432_file-logosat-sat-logo-png-transparente-png-download-removebg-preview 1.png" />
  
        </v-tab>
        <v-tab class="tabhvr" href="#tab-5" style="border-right:2px solid;border-top:2px solid;border-bottom:2px solid;border-color:grey;" @click="gmatBtn()">
          <!-- <h5 class="tabfont">GMAT</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/1280px-GMAT_Logo_Vector.png" />
        </v-tab>
        <v-tab class="tabhvr" href="#tab-6" style="cursor:pointer;background-color:#f4f4f4;color:white;" @click="examBtn()">
          <!-- <h5 class="tabfont">CAT, MAT AND OTHER MBA ENTRANCE EXAMS</h5> -->
          <img class="center tab-logo"  src="../../assets/Logoss/pte.png" />
  
        </v-tab>
                </v-tabs>
  
      
              </v-container>
  
              <v-container v-if="ielts==true">
                <p style="text-align:justify;color:black;" class="txt">
                  IELTS stands for International English language Testing Systems and is designed to test the ability of students on 4 basic parameters of English - speaking, reading, listening and writing. The test is for individuals who are looking at studying or working in countries where English is the main language of instruction such as Australia, Canada, UK, USA and New Zealand.
                </p>
  
                <p style="text-align:center;color:black;font-weight:bold;" class="txt">There are four sections or modules</p>
  
                <div class="row">
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:20px;padding-top:7px;color:white;">Reading</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:20px;padding-top:7px;color:white;">Writing</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:20px;padding-top:7px;color:white;">Listening</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:20px;padding-top:7px;color:white;">Speaking</h1>
                    </v-avatar>
                  </div>
                </div>
  
                <p style="text-align:center;color:black;padding-top:20px;" class="txt">Students must appear for all the four sections.</p>
              
                <p style="text-align:center;color:black;font-weight:bold;" class="txt">IELTS is of two types</p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>ACADEMIC</th>
                              <th>GENERAL TRAINING</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr style="font-size:15px;" >
                                  <td>
                                    For students who want to apply to undergraduate or postgraduate courses in English speaking countries.
                                  </td>
                                  <td>
                                    For students taking vocational training and for those applying for immigration.
                                  </td>
                              </tr>
                          </tbody>
                </table>
                    </div>
  
                    <p style="text-align:justify;color:black;padding-top:20px;" class="txt">The Listening and Speaking modules are the same for Academic and General Training whereas the Reading and Writing modules vary with whether the student wants to take Academic or General Training.</p>
  
                      <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>MODULES</th>
                              <th>SECTIONS</th>
                              <th>TIMINGS</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr >
                              <td> LISTENING</td>
                              <td>4 SECTIONS/40 ITEMS</td>
                              <td>30 MINUTES</td>
                            </tr>
                            <tr >
                              <td> READING</td>
                              <td>3 SECTIONS/40 ITEMS</td>
                              <td>60 MINUTES</td>
                            </tr>
                            <tr >
                              <td> WRITING</td>
                              <td>2 TASKS</td>
                              <td>60 MINUTES</td>
                            </tr>
                            <tr >
                              <td> SPEAKING</td>
                              <td>TOPIC PROVIDED</td>
                              <td>11 TO 14 MINUTES</td>
                            </tr>
                          </tbody>
                </table>
                    </div>
  
                    <p style="text-align:justify;color:black;padding-top:20px;" class="txt">
                      IELTS test takers are given a band from 1 to 9, with 0.5 increments. IELTS has a validity of 2 years. Generally, universities expect a score around 6.5, or 6, with no band width less than 6. The overall band score is calculated by taking all the average of the individual scores.
                    </p>
                    <p style="text-align:justify;color:black;padding-top:20px;" class="txt">
                      The <span style="font-weight:bold;">IELTS Test Fee</span> ranges from <span style="font-weight:bold;">INR 14000 to INR 16000.</span>
                    </p>
                    <p style="text-align:justify;color:black;" class="txt">
                      The Test Report Form (TRF) will be available to you 13 calendar days after your test date.
                    </p>
  
                    <p style="text-align:justify;color:black;font-weight:bold;" class="txt">
                      Worldwin Fee Structure
                    </p>
                    <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>EXAM (TRAINING FEES)</th>
                              <th>FEES</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td>IELTS (ACADEMIC)</td>
                                  <td>6500</td>
                              </tr>
                              <tr >
                                  <td>ELTS (GENERAL TRAINING)</td>
                                  <td>10000</td>
                              </tr>
                              <tr >
                                  <td>TOEFL/PTE</td>
                                  <td>10000</td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt my-10">
                  FAQs
                </p>
                <div id="inspire" style="margin-bottom:50px">
                  <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What is the main difference between IELTS and TOEFL?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            IELTS is Paper-Based whereas TOEFL is an online exam.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How many hours of coaching will Worldwin provide?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Worldwin provides 30 hours of classes (2 hours per class). Students who are preparing for IELTS academic and are weak in English and need more hours to get the required score will be given extra hours without additional cost.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do students need to buy material for the exam?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            No, Worldwin will provide all necessary material to its students.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How many mock tests is each student provided?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Students are provided with as many mock tests as needed.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do I need to register for the main exam myself?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Worldwin is an official partner of British Council and will help students with their exam registration.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Why choose Worldwin for IELTS/ TOEFL?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                              <ul>
                                <li>Experienced and British Council Certified Faculty</li>
                                <li>Small Batch Size</li>
                                <li>One-on-One Student Attention</li>
                                <li>Flexible timing</li>
                                <li>Both online and offline options available</li>
                                <li>Affordable Fee Structure </li>
                                <li>Class extension if needed without additional charges</li>
                                <li>Official Study Material provided</li>
                              </ul>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                </div>
              </v-container>
  
              <v-container v-if="toefl==true">
                <p style="text-align:justify;color:black;" class="txt">
                  TOEFL is another English Proficiency Examination that is widely accepted by colleges to judge students on four basic English Language skills i.e. Reading, Writing, Listening and Speaking. Accepted by more than 11,000 universities over 150 universities, this test is computer based and takes 3 hours to be completed.
                </p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>SECTIONS</th>
                              <th>TIME AND QUESTIONS</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td>READING</td>
                                  <td>30-40 QUES/ 54-72 MINUTES</td>
                              </tr>
                              <tr >
                                  <td>LISTENING</td>
                                  <td>28-39 QUES/ 41-57 MINUTES</td>
                              </tr>
                              <tr >
                                  <td>SPEAKING</td>
                                  <td>4 TASKS/ 17 MINUTES</td>
                              </tr>
                              <tr >
                                  <td>WRITING</td>
                                  <td>2 TASKS/ 50 MINUTES</td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:right;color:black;font-weight:bold;" class="txt">TOEFL Test Fee- 
                  <v-avatar :size="55" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:17px;padding-top:7px;color:white;">$185</h1>
                    </v-avatar>
                </p>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt">
                  Worldwin Fee Structure
                </p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>EXAM</th>
                              <th>FEES</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td>IELTS (ACADEMIC)</td>
                                  <td>6500</td>
                              </tr>
                              <tr >
                                  <td>ELTS (GENERAL TRAINING)</td>
                                  <td>10000</td>
                              </tr>
                              <tr >
                                  <td>TOEFL/PTE</td>
                                  <td>10000</td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt my-10">
                  FAQs
                </p>
  
                <!-- <template>
                    <v-row justify="center">
                      <v-expansion-panels accordion>
                        <v-expansion-panel
                        >
                          <v-expansion-panel-header>Item</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                  </template> -->
                <!-- <p style="background-color:#bfb9b9;padding:10px;text-align:center;font-size:18px;">FAQ's</p> -->
   
                <div id="inspire" style="margin-bottom:50px">
                  <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What is the main difference between IELTS and TOEFL?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            IELTS is Paper-Based whereas TOEFL is an online exam.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How many hours of coaching will Worldwin provide?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Worldwin provides 30 hours of classes (2 hours per class). Students who are preparing for IELTS academic and are weak in English and need more hours to get the required score will be given extra hours without additional cost.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do students need to buy material for the exam?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            No, Worldwin will provide all necessary material to its students.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How many mock tests is each student provided?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Students are provided with as many mock tests as needed.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do I need to register for the main exam myself?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Worldwin is an official partner of British Council and will help students with their exam registration.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Why choose Worldwin for IELTS/ TOEFL?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                              <ul>
                                <li>Experienced and British Council Certified Faculty</li>
                                <li>Small Batch Size</li>
                                <li>One-on-One Student Attention</li>
                                <li>Flexible timing</li>
                                <li>Both online and offline options available</li>
                                <li>Affordable Fee Structure </li>
                                <li>Class extension if needed without additional charges</li>
                                <li>Official Study Material provided</li>
                              </ul>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                </div>
              </v-container>
  
              <v-container v-if="gre==true">
                <p style="text-align:justify;color:black;" class="txt">
                  GRE stands for Graduate Record Examinations and it is used by universities in USA and Canada to judge students on the basis of verbal reasoning, quantitative reasoning, analytical skills and critical thinking for their graduate level programs. The exam is conducted by ETS (Education Testing Service) and has over 1000 test centers across 160 countries.
                </p>
                <p style="text-align:justify;color:black;" class="txt">
                  The exam is computer based and of 3 hours and 45 minutes approximately.
                </p>
                <p style="text-align:justify;color:black;padding-top:20px;font-weight:bold;" class="txt">GRE Test Structure</p>
  
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>Section</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr style="font-size:15px;" >
                                  <td>Analytical Writing(2 tasks)</td>
                                  <td>30minutes / task</td>
                              </tr>
                              <tr style="font-size:15px;" >
                                  <td>Verbal Reasoning (2 sections)</td>
                                  <td>30 minutes/ section</td>
                              </tr>
                              <tr style="font-size:15px;" >
                                  <td>Quantitative Reasoning (2 sections)</td>
                                  <td>35 minutes/ section</td>
                              </tr>
                              <tr style="font-size:15px;" >
                                  <td>Unscored / Research Section</td>
                                  <td>Varies</td>
                              </tr>
                          </tbody>
                </table>
                    </div>
                <p style="text-align:justify;color:black;padding-top:20px;font-weight:bold;" class="txt">Validity- 5 years</p>
                <p style="text-align:justify;color:black;" class="txt">
                  GRE also has specific subject tests that allow universities to measure the student’s expertise of a certain subject.
                </p>
  
  
                <div class="row">
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Biology<br/> Test</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Chemistry<br/> Test</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Literature in English<br/> Test</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Mathematics<br/> Test</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Psychology<br/> Test</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Physics<br/> Test</h1>
                    </v-avatar>
                  </div>
                </div>
                <p style="text-align:justify;color:black;padding-top:20px;" class="txt">
                      The GRE General Test fee in India is <span style="font-weight:bold;">$213 or INR 15,800</span> approximately.
                    </p>
                    <p style="text-align:justify;color:black;font-weight:bold;" class="txt">
                  Worldwin Fee Structure
                </p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>EXAM</th>
                              <th>Crash Course (30 Hours)</th>
                              <th>General Course (60 Hours)</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td>SAT</td>
                                  <td></td>
                                  <td></td>
                              </tr>
                              <tr >
                                  <td>GRE</td>
                                  <td>30,000</td>
                                  <td>55,000</td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt my-10">
                  FAQs
                </p>
                <div id="inspire" style="margin-bottom:50px">
                  <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What is the batch size for GRE/SAT Training?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            IWorldwin provides one to one coaching to its students.                        
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Each class is of many hours?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Each class is for 2 hours.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Is GRE/SAT very tough?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            GRE is tougher as it is for post graduate programs.                         </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How much do I need to score to get into a good university?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            A student needs 320+ out of 340.
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do I need to buy study material separately?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            No, unless the students wants to. Worldwin will provide the required study material.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Why choose Worldwin for GRE/ SAT?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                              <ul>
                                <li>Experienced and Certified Faculty</li>
                                <li>One-on-One Student Attention</li>
                                <li>Flexible timing</li>
                                <li>Both online and offline options available</li>
                                <li>Affordable Fee Structure </li>
                                <li>Installment Option Available</li>
                                <li>Official Study Material provided</li>
                                <li>Crash Course Available</li>
                              </ul>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                </div>
              </v-container>
  
          <v-container v-if="sat==true">
                <p style="text-align:justify;color:black;" class="txt">
                  SAT stands for Scholastic Assessment Test and is a standardized test conducted by College Board and is extensively used by colleges especially in the United States and Canada for admission to undergraduate programs of universities. It judges student on the basis of their written, verbal and mathematical skills. For students looking to take admission in a particular course can specifically sit for SAT Subject Tests which is offered for various subjects such as
                </p>
                <div class="row">
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Literature</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">History</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Mathematics</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Science</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:15px;padding-top:7px;color:white;">Foreign Languages</h1>
                    </v-avatar>
                  </div>
                </div>
                <p style="text-align:center;color:black;font-weight:bold;padding-top:15px;padding-bottom:10px;" class="txt">SAT Fee:</p>
                <p style="text-align:center;">
                  <v-avatar :size="70" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:10px;padding-top:7px;color:white;">$101<br/>(without essay)</h1>
                    </v-avatar>
                     &nbsp;&nbsp;
                    <v-avatar :size="70" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:10px;padding-top:7px;color:white;">$117<br/>(with essay)</h1>
                    </v-avatar>
                </p>
             
              <p style="text-align:justify;color:black;font-weight:bold;" class="txt">
                  Worldwin Fee Structure
                </p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>EXAM</th>
                              <th>Crash Course (30 Hours)</th>
                              <th>General Course (60 Hours)</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td>SAT</td>
                                  <td></td>
                                  <td></td>
                              </tr>
                              <tr >
                                  <td>GRE</td>
                                  <td>30,000</td>
                                  <td>55,000</td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt my-10">
                  FAQs
                </p>
                <div id="inspire" style="margin-bottom:50px">
                  <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What is the batch size for GRE/SAT Training?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            IWorldwin provides one to one coaching to its students.                        
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Each class is of many hours?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Each class is for 2 hours.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Is GRE/SAT very tough?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            GRE is tougher as it is for post graduate programs.                         </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How much do I need to score to get into a good university?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            A student needs 320+ out of 340.
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do I need to buy study material separately?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            No, unless the students wants to. Worldwin will provide the required study material.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Why choose Worldwin for GRE/ SAT?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                              <ul>
                                <li>Experienced and Certified Faculty</li>
                                <li>One-on-One Student Attention</li>
                                <li>Flexible timing</li>
                                <li>Both online and offline options available</li>
                                <li>Affordable Fee Structure </li>
                                <li>Installment Option Available</li>
                                <li>Official Study Material provided</li>
                                <li>Crash Course Available</li>
                              </ul>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                </div>
              </v-container>
              <!-- **************************************** SAT END **********************************-->
              <v-container v-if="gmat==true">
                <p style="text-align:justify;color:black;" class="txt">
                  GMAT or Graduate Management Admission test is a computer based standardized test that is conducted by GMAC (Graduate Management Admission Council) for students who wish to be admitted to graduate management programs. This exam is accepted by more than 3000 graduate programs all over the world.  The exam is divided into 4 sections Analytical Writing Assessment, Integrated Reasoning, Quantitative and Verba test the reasoning and analytical skills of students.
                </p>
                <p style="text-align:justify;color:black;padding-top:20px;" class="txt">Test format:</p>
  
                      <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>Sections</th>
                              <th>No. of Questions</th>
                              <th>Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr >
                              <td> Analytical Writing Assessment</td>
                              <td>1</td>
                              <td>30 MINUTES</td>
                            </tr>
                            <tr >
                              <td> Integrated Reasoning</td>
                              <td>12</td>
                              <td>30 MINUTES</td>
                            </tr>
                            <tr >
                              <td> Quantitative </td>
                              <td>31</td>
                              <td>62 MINUTES</td>
                            </tr>
                            <tr >
                              <td> Verbal </td>
                              <td>36</td>
                              <td>65 MINUTES</td>
                            </tr>
                          </tbody>
                </table>
                    </div>
  
                    <div class="row">
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:12px;padding-top:7px;color:white;">800<br/>Total Marks</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:12px;padding-top:7px;color:white;">3 hour 30 minutes<br/>Total duration</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:12px;padding-top:7px;color:white;">$200<br/>Total Fee</h1>
                    </v-avatar>
                  </div>
                  <div class="col" style="text-align:center;">
                    <v-avatar :size="100" style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size;border: 1px solid;border-color:black">
                      <h1 style="font-size:12px;padding-top:7px;color:white;">5 years<br/>Test score Validity</h1>
                    </v-avatar>
                  </div>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;margin-top: 50px;" class="txt">
                  Worldwin Fee Structure
                </p>
                <div class="body table-responsive" >
                <table class="table table-bordered">
                    <thead>
                            <tr style="background-color:#bfb9b9;">
                              <th>Course</th>
                              <th>Fees</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr >
                                  <td></td>
                                  <td></td>
                              </tr>
                              <tr >
                                  <td></td>
                                  <td></td>
                              </tr>
                          </tbody>
                </table>
                </div>
                <p style="text-align:justify;color:black;font-weight:bold;" class="txt my-10">
                  FAQs
                </p>
                <div id="inspire" style="margin-bottom:50px">
                  <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What is a good score of GMAT?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            The quantitative section of GMAT is tougher than GRE. However, for students who prefer logical problems might prefer GMAT over GRE.                        
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">GRE or GMAT, which is more difficult?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            The quantitative section of GMAT is tougher than GRE. However, for students who prefer logical problems might prefer GMAT over GRE.
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">How many times can I sit for GMAT?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            A student can sit for an exam 5 times in 12 months. (Not more than once in 16 days)                     
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">What will be the training batch size?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Worldwin provided one to one class to its students.
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Do Indian B-schools accept GMAT?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            Yes. Some top colleges such as IIMs, ISB, Xavier Institute of Management, IMT, Sp Jain, Welingkar Institute of Management , Development and Research ,IMI , etc. accept GMAT score.                       
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                    <v-row justify="center">
                      <v-expansion-panels accordion >
                        <v-expansion-panel >
                          <v-expansion-panel-header style="text-align:justify;color:black;font-weight:600;">Why choose Worldwin for training?</v-expansion-panel-header>
                          <v-expansion-panel-content>
                              <ul>
                                <li>One to one mentoring</li>
                                <li>Regular customized mock test</li>
                                <li>Comprehensive study material</li>
                                <li>Long term counseling</li>
                                <li>Exam workshops</li>
                                <li>Diagnostic assessments</li>
                              </ul>
                           </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                </div>
              </v-container>
              
              <v-container v-if="exam==true">
                <p style="text-align:justify;color:black;" class="txt">
                  The Pearson Test of English Academic is an English language test designed to assess the readiness of non-native English speakers to participate in a university-level English language instruction program. Pearson created PTE Academic in response to demand from institutions, government and other organizations for a more accurate way of testing non-native English language students who enter the English-speaking academia world.
                </p>
                <div  >
            <h2 style="font-weight:500;margin-bottom: 20px;">Details of PTE Academics online Test</h2>
            <h6 class="txt" style="text-align:justify;"><strong>Test format</strong> </h6>
            <div class="body table-responsive" >
              <table class="table table-bordered">
              <thead>
                    <tr style="background-color:#bfb9b9;">
                      <th>Part</th>
                      <th>Type</th>
                      <th>Timing</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <td>A</td>
                      <td>Speaking & Writing</td>
                      <td>54-67 minutes</td>
                      <td>There are seven distinct question categories in this 54-67 minute section of the exam. It is the test's longest portion. English that you may hear in an academic setting will be used to assess your speaking and writing abilities.</td>
                    </tr>
                    <tr>
                      <td>B</td>
                      <td>Reading</td>
                      <td>29-30 minutes</td>
                      <td>There are five distinct question categories in this 29 to 30 minute section of the test. One item type ('Reading and Writing: Fill in the Blanks') on the PTE Academic measures writing abilities because it is an integrated skills exam.</td>
                    </tr>
                    <tr>
                      <td>C</td>
                      <td>Listening</td>
                      <td>30-43 minutes</td>
                      <td>There are eight distinct question categories in this 30- to 43-minute section of the exam. <br> The audio or video samples that provide the basis for the questions start to play automatically. Each audio or video clip is only heard once. You're free to jot down notes.
</td>
                    </tr>

                  </tbody>
              </table>
              </div>

                <p class="txt" style="text-align:justify;">Fees Structure</p>
                          <p class="txt" style="text-align:justify;">FAQ
                  <ol>
                    <li>What is a good score of PTE?</li>
                    <li>IELTS or PTE, which is more difficult?</li>
                    <li>How many times can I sit for PTE?</li>
                    <li>What will be the training batch size?</li>
                    <li>Does Australian University accept PTE scores?</li>
                    <li>Which country Accept PTE score?</li>
                  </ol>
                </p>
            <p class="txt" style="text-align:justify;"></p>
          </div> 
              </v-container>
            </div>
  <!-- ********************************************************** APPLY NOW FORM *************************************************************
   -->
            <div class="col-lg-3 col-md-3 col-sm-12">
                <v-card flat style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;margin-top:20px;padding:30px;">
                    <div style="background-color:black;color:white;text-align:center;padding:15px;">
                        <h2>Apply Now</h2>
                    </div>
                    <v-container v-if="otp==false">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout row wrap >
                                <v-flex xs12 style="padding-top:10px;" >
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" a-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCountry"
                                     :items="countries"
                                     color="primary"
                                     label="Preferred Country *"
                                     item-text="countryName"
                                     item-value="countryName"
  
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCourse"
                                     :items="courses"
                                     color="primary"
                                     label="Preferred Course *"
                                     item-text="courses"
                                     item-value="courses"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                    <v-container v-if="otp==true">
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <label>Enter Your OTP here *</label>
                                    <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                </v-card>
            </div>
        </div>
  
        <v-dialog v-model="dialog" width="500px" persistent>
           <v-card>
             <div style="height:150px;background-color:green;text-align:center;">
               <div style="padding-top:25px;">
                  <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
               </div>
             </div>
             <v-container>
               <div style="text-align:center">
                   <h4>Thank You</h4>
                   <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                   <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
               </div>
             </v-container>
           </v-card>
       </v-dialog>
    </v-app>
  </template>
  
  <script>
  import config from "./../../config.json";
  import moment from 'moment';
  export default {
    components: {
    },
    data() {
      return {
        valid: true,
        btnSave: false,
        btnSave1: false,
        dialog: false,
        status: false,
        pin: 0,
        otp: false,
        name: [],
  
        ielts: true,
        toefl: false,
        gre: false,
        sat: false,
        gmat: false,
        exam: false,
  
        countries: [],
        selectedCountry: null,
  
        courses: ['IELTS', 'TOEFL', 'GRE', 'SAT', 'GMAT'],
        selectedCourse: null,
  
        form: {
          name: null,
          email: null,
          mobileNumber: null
        },
        form1: {
          otp: null
        },
        emptyRule: [v => !!v || "Input is required"],
        rules: {
          required: value => !!value || "Required.",
          email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
          },
          mobileno: value => {
            const pattern = /^[1-9]{1}[0-9]{9}$/;
            return pattern.test(value) || "Mobile number not valid!!";
          },
        },
      };
      
    },
    
    mounted() {
      this.axios
          .get(config.API + "servicetype/author/" + 1, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(res => {
            this.description = res.data.author.description;
            
            let list = res.data.list;
  
            for (let index = 0; index < list.length; index++) {
              const element = list[index];
  
              this.list.push({
                id: element.id,
                title: element.title,
                description: element.description,
                src: config.API1 + "service/files/" + element.src
              })
            }
  
            console.log(this.list);
            this.$Progress.finish();
          })
          .catch(() => {
            this.$Progress.fail();
          }); 
       
       this.axios
        .get(config.API + `country/authors`, {
          headers: { Authorization: "Bearer " + sessionStorage.token }
        })
        .then(res => {
          let list = res.data.authors;
          this.countries = list;
        });
     },
  
   methods: {
     blg(item) {
       sessionStorage.setItem("blogTitle", item.title);
       sessionStorage.setItem("blogDescription", item.description);
       sessionStorage.setItem("blogSrc", item.src);
       sessionStorage.setItem("brochureSrc", item.brochureSrc);
       this.$router.push("/test-preparation-detail/" + item.id );
     },
  
     getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Test: " + this.selectedCourse;
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              comment: comment,
              pageName: 'Test Preparation',
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: "Website",
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        }
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      /* } else {
        this.$toaster.error(`Required field are empty!!`);
      } */
    },
  
      onSubmit() {
        if (this.$refs.form1.validate()) {
          if(this.pin == this.form1.otp) {
            this.btnSave1 = true;
          this.axios
            .post(
              config.API + `enquiry/author`,
              {
                name: this.form.name,
                email: this.form.email,
                mobileNumber: JSON.parse(this.form.mobileNumber),
                country: this.selectedCountry,
                course: this.selectedCourse,
                page: 'Test Preparation',
                date: moment().format('MMMM Do YYYY')
              },
              {
                headers: {
                  Authorization: "bearer " + sessionStorage.getItem("token")
                }
              }
            )
            .then(res => {
              console.log(res);
              this.name = this.form.name.split(' ');
              let firstName = this.name[0];
              let lastName = null;
  
              if(this.name.length > 2) {
                lastName = this.name[1] + this.name[2]
              }
              else {
                lastName = this.name[1]
              }
              this.axios
            .post(
              `http://api.worldwin.org/api/Leads1`,
              {
                firstName: firstName,
                lastName: lastName,
                mobileNumber: JSON.parse(this.form.subject),
                cmsId: JSON.parse(res.data.result.id),
                email: this.form.email,
                guardianName: null,
                guardianNo: 0,
                guardianEmail: null,
                relation: null,
                address: null,
                nature: null,
                source: null,
                document: false,
                documentType: null,
                notes: null,
                levelId: 0,
                leadDetails: null,
                leadTrainings: null
              },
              {
                headers: {
                  Authorization: "bearer " + localStorage.getItem("token")
                }
              }
            )
            .then(res => {
              this.dialog = true;
              this.btnSave1 = false;
            })
            .catch(() => {
              this.$toaster.error(`Mobile no is already registered`);
              this.btnSave = false;
            });
            })
            .catch(() => {
              this.$toaster.error("Mobile no is already registered");
              this.btnSave1 = false;
            });
          }
          else {
            this.$toaster.error("Please put a valied OTP");
          }
        } else {
          this.$toaster.error(`Required field are empty!!`);
        }
      },
  
      cancel() {
          this.$refs.form1.reset();
          this.otp = false;
          this.dialog = false;
      },
  
     ieltsBtn() {
       this.ielts = true;
       this.toefl = false;
       this.gre = false;
       this.sat = false;
       this.gmat = false;
       this.exam = false;
     },
     toeflBtn() {
       this.ielts = false;
       this.toefl = true;
       this.gre = false;
       this.sat = false;
       this.gmat = false;
       this.exam = false;
     },
     greBtn() {
       this.ielts = false;
       this.toefl = false;
       this.gre = true;
       this.sat = false;
       this.gmat = false;
       this.exam = false;
     },
     satBtn() {
       this.ielts = false;
       this.toefl = false;
       this.gre = false;
       this.sat = true;
       this.gmat = false;
       this.exam = false;
     },
     gmatBtn() {
       this.ielts = false;
       this.toefl = false;
       this.gre = false;
       this.sat = false;
       this.exam = false;
       this.gmat = true;
     },
     examBtn() {
       this.ielts = false;
       this.toefl = false;
       this.gre = false;
       this.sat = false;
       this.gmat = false;
       this.exam = true;
     },
   }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Secular+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
  </style>
  
  <style scoped>
  .tabfont {
    font-family: 'Secular One', sans-serif;
    font-size: 27px;
  }
  .tabhvr:hover {
    border: none !important;
    background-color: #F13926;
    color: white !important;
  }
  .banner {
    background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
    background-size: cover;
    height:200px;
  }
  .tst {
      background-image: linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url('https://www.Worldwininternational.com/images/img19.png');
      background-size: cover;
      color: white !important;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  
  .partner {
      margin-top: 15px;
      text-align: center;
      font-size: 23px;
      background-image: linear-gradient(to right, #f19a28 , #f12525);
      border-radius: 0px !important;
      color: whitesmoke !important;
  }
  .text_dec:hover {
    text-decoration: none !important;
  }
  
  .hvr:hover {
    cursor: pointer;
    /* height: 200px; */
    border : 2px solid;
    border-color: black !important;
  }
  .hvr1:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #2196f3;
  }
  .v-card {
    padding: 10px;
    border-radius: 8px;
  }
  .v-sheet--offsets {
    top: -50px;
    position: relative;
  }
  .v-sheet--offset {
    top: -30px;
    position: relative;
  }
  .v-sheet--offsetf {
    top: -100px;
    position: relative;
  }
  .swo {
    box-shadow: none !important;
  }
  .opa {
    opacity: 1;
  }
  div.scroll { 
                  margin:4px, 4px; 
                  padding:4px; 
                  width: auto; 
                  height: 254px; 
                  overflow-x: hidden; 
                  overflow-x: auto; 
                  text-align:justify; 
              }
  .tourtheme {
    height: 180px;
    margin: 5px;
    background-size: cover;
  }
  .themecap {
    font-family: 'Open Sans', sans-serif;
    padding-top: 130px;
    color: white;
  }
  .top-left {
    font-family: 'Roboto Mono', monospace;
    font-size:40px ;
    padding-top: 200px;
    color: white;
    text-align: center;
  }
  .salont {
    font-family: 'Patua One', cursive;
  }
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .hvr:hover {
    cursor: pointer;
    border-radius: 5px !important;
    border : 1px solid;
    border-color: black !important;
    transition-duration: 0.7s;
    text-decoration: none !important;
  }
  .v-table tbody tr:not(:last-child) {
      border-bottom: none !important;
  }
  @media screen and (max-width: 768px) {
    .res {
      display: none;
    }
  }
  @media screen and (min-width: 768px){
    .man {
      display: none;
    }
  }
  img.center {
      display: block;
      margin: 0 auto;
  }
  .recent {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .srch {
    position: absolute;
    z-index: 10;
    left: 16%;
    top: 0%;
  }
  .item {
      border:1px solid !important;
  }
  .tab-logo {
    height:50px;
    padding:10px;
  }
  .v-tab {
    padding: 0px;
  }
  </style>
  